export default __webpack_public_path__ + "img/icon-success.0838f26a.png";